import { createContext, useContext } from 'react';
import { WizardValues } from 'react-use-wizard';

export const PaymentContext = createContext<{
  jobId: number;
  isLoadingQuote: boolean;
  formatPrice: (price: number) => string;
  asMember: boolean;
  wizardFunctions: React.MutableRefObject<WizardValues | null>;
  committedQuoteId: number | null;
  setCommittedQuoteId: (id: number | null) => void;
  // Pay Invoice for an existing issued invoice: pay this quote (owner's, locked
  // snapshot) instead of committing a new one. Null in the normal checkout flow.
  payQuoteId: number | null;
  isRfqOrder: boolean;
  committedRequestForQuoteId: number | null;
  lastCommittedMembershipPriceId: string | null;
  setLastCommittedMembershipPriceId: (id: string) => void;
} | null>(null);

export const usePaymentContext = () => {
  const ctx = useContext(PaymentContext);
  if (!ctx) {
    throw new Error('Must be inside PaymentContext.Provider');
  }
  return ctx;
};
